import { combineReducers, configureStore } from "@reduxjs/toolkit";
import {
	createMigrate,
	FLUSH,
	PAUSE,
	PERSIST,
	persistReducer,
	persistStore,
	PURGE,
	REGISTER,
	REHYDRATE,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

import alertReducer from "./alertSlice";
import { migrations } from "./migrations";
import navigationReducer from "./navigationSlice";
import userReducer from "./userSlice";

const persistConfig = {
	key: "root",
	version: 6,
	storage,
	migrate: createMigrate(migrations, { debug: process.env.REACT_APP_ENVIRONMENT === "dev" ? true : false })
};

const persistedReducer = persistReducer(persistConfig, combineReducers({ user: userReducer, navigation: navigationReducer }));

const rootReducer = persistedReducer;

const store = configureStore({
	reducer: {
		alert: alertReducer,
		root: rootReducer
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: {
				ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
			},
		}),
});

/**
 * Setup for testing comps that manipulate redux state.
 */

export const setupStore = (preloadedState) => {
	return configureStore({
		reducer: {
			alert: alertReducer,
			root: rootReducer
		},
		preloadedState,
		middleware: (getDefaultMiddleware) =>
			getDefaultMiddleware({
				serializableCheck: {
					ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
				},
			}),
	});
};

export let persistor = persistStore(store);
export default store;